import { injectEmspBoRfidBadgeOrderApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/emsp-bo-rfid-badge-order.service';

import { baseApi } from '@service/base-api.service';

export const emspBoRfidBadgeOrderApi = injectEmspBoRfidBadgeOrderApi(baseApi);

export const {
  useEmspBoGetRfidBadgeOrdersPaginatedQuery,
  useEmspBoGetRfidBadgeOrderQuery,
  useEmspBoFulfillRfidBadgeOrderMutation,
} = emspBoRfidBadgeOrderApi;
